import { render } from "./batchSearch.vue?vue&type=template&id=bf48c906&scoped=true"
import script from "./batchSearch.vue?vue&type=script&lang=js"
export * from "./batchSearch.vue?vue&type=script&lang=js"

import "./batchSearch.vue?vue&type=style&index=0&id=bf48c906&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf48c906"]])

export default __exports__